import React, { useState, createContext, useEffect } from "react";
import { allMoments, allMembers } from "../api";
import { GetYears } from "../components/helpers/GetYears";

export const Moments = createContext();

const MomentsContextProvider = (props) => {
    const [filter, setFilter] = useState({
        members: [],
        location: [],
        tags: [],
    });
    const [filterLeft, setFilterLeft] = useState({
        members: [],
        location: [],
        tags: [],
    });
    const [filterRight, setFilterRight] = useState({
        members: [],
        location: [],
        tags: [],
    });
    const [isCompareView, setIsCompareView] = useState(false);
    const [isMonthView, setIsMonthView] = useState(true);
    const [isLikeView, setIsLikeView] = useState(false);
    const [likedMoments, setLikedMoments] = useState([]);
    const [countLikedMoments, setCountLikedMoments] = useState(0);
    const [gallerySize, setGallerySize] = useState({ width: 0, height: 0 });
    const [locations, setLocations] = useState([]);
    const [tags, setTags] = useState([]);
    const [sortedAllMoments, setSortedAllMoments] = useState([]);
    const [filteredMoments, setFilteredMoments] = useState([]);
    const [currentMomentID, setCurrentMomentID] = useState("");
    const [currentDate, setCurrentDate] = useState("");
    const [latestDate, setLatestDate] = useState("");
    const [filteredYears, setFilteredYears] = useState([]);
    const [invalidFilter, setInvalidFilter] = useState(false);
    //Filter Left
    const [filteredMomentsLeft, setFilteredMomentsLeft] = useState([]);
    const [filteredYearsLeft, setFilteredYearsLeft] = useState([]);
    const [currentMomentIDLeft, setCurrentMomentIDLeft] = useState("");
    const [currentDateLeft, setCurrentDateLeft] = useState("");
    //Filter Right
    const [filteredMomentsRight, setFilteredMomentsRight] = useState([]);
    const [filteredYearsRight, setFilteredYearsRight] = useState([]);
    const [currentMomentIDRight, setCurrentMomentIDRight] = useState("");
    const [currentDateRight, setCurrentDateRight] = useState("");

    useEffect(() => {
        const _sortedMoments = allMoments.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.date) - new Date(b.date);
        });
        // get liked status
        const _likedMoments = _sortedMoments.filter((moment) => moment.isLike);

        setLikedMoments(
            _likedMoments.map((_m) => {
                return _m.id;
            })
        );
        // get initialpositions
        setSortedAllMoments(getPositionsAndSizes(_sortedMoments));
    }, []);

    const getPositionsAndSizes = (_filteredMoments) => {
        // resolution: 1 for 72dpi,
        // resolution: 2 for 144dpi
        const res = 2;

        const spacing = 40 * res;
        let _gallerySize = {
            width: 0,
            height: 0,
        };
        _filteredMoments.map((_moment, i) => {
            _moment.index = i;

            // vertical format
            let verticalHeight = Math.round((window.innerWidth * 0.2 * _moment.media.height) / _moment.media.width) * res;
            let verticalWidth = Math.round(window.innerWidth * 0.2) * res;
            if (verticalHeight > Math.round(window.innerHeight * 0.4) * res) {
                // if height is over 40% of height, limit height
                verticalHeight = Math.round(window.innerHeight * 0.4) * res;
                verticalWidth = Math.round((window.innerHeight * 0.4 * _moment.media.width) / _moment.media.height) * res;
            }
            // horizontal format
            let horizontalHeight = Math.round(window.innerHeight * 0.33) * res;
            let horizontalWidth = Math.round((window.innerHeight * 0.33 * _moment.media.width) / _moment.media.height) * res;

            if (_filteredMoments[i - 1]) {
                _gallerySize.height += spacing + verticalHeight * 0.5 + _filteredMoments[i - 1].vertical.height * 0.5;
                _gallerySize.width += spacing + horizontalWidth * 0.5 + _filteredMoments[i - 1].horizontal.width * 0.5;
            }
            _moment.horizontal = {
                x: _gallerySize.width,
                y: 0,
                width: horizontalWidth,
                height: horizontalHeight,
            };
            _moment.vertical = {
                x: 0,
                y: -_gallerySize.height,
                width: verticalWidth,
                height: verticalHeight,
            };
            _moment.left = _moment.horizontal.x - _moment.horizontal.width * 0.5;
            _moment.right = _moment.horizontal.x + _moment.horizontal.width * 0.5;
            _moment.top = _moment.vertical.y - _moment.vertical.height * 0.5;
            _moment.bottom = _moment.vertical.y + _moment.vertical.height * 0.5;
            return _moment;
        });
        setGallerySize(_gallerySize);

        return _filteredMoments;
    };

    // Make a list of all available locations, for search function.
    const getLocations = (_filteredMoments) => {
        const _locations = [];
        _filteredMoments.map((_moment) => {
            if (!_locations.includes(_moment.location)) {
                _locations.push(_moment.location);
            }
            return null;
        });
        return _locations;
    };

    // Make a list of all available tags, for search function.
    const getTags = (_filteredMoments) => {
        let _tags = [];
        //const key = 'tag';
        _filteredMoments.map((_moment) => {
            _moment.tags.map((_momentTags) => {
                if (!_tags.includes(_momentTags) && _momentTags.length > 0) {
                    _tags.push(_momentTags);
                }
                return null;
            });
        });
        return _tags;
    };

    const onLike = (likedMoment) => {
        // update like in master sorted array.
        sortedAllMoments.find((_moment) => _moment.id === likedMoment.id).isLike = likedMoment.isLike;
        setLikedMoments(sortedAllMoments.filter((_moment) => _moment.isLike).map((_moment) => _moment.id));
    };

    // ////////////////////////////////////////
    //
    // FILTER MOMENTS
    //
    // ////////////////////////////////////////
    const applyFilter = (_filter) => {
        if (_filter.members.length > 0 || _filter.location.length > 0 || _filter.tags.length > 0) {
            const _filteredMoments = checkFilter(_filter);
            if (_filteredMoments.length) {
                if (isLikeView) {
                    return getPositionsAndSizes(_filteredMoments.filter((m) => m.isLike));
                } else {
                    return getPositionsAndSizes(_filteredMoments);
                }
            }
        }
        if (isLikeView) {
            return getPositionsAndSizes(sortedAllMoments.filter((m) => m.isLike));
        } else {
            return getPositionsAndSizes(sortedAllMoments);
        }
    };

    const checkFilter = (_filter) => {
        // check filter.members array has any matches with _moment's members
        const filterMembers = (_moment) => {
            const members = _filter.members.filter((member) => {
                const _members = _moment.members.filter((_member) => {
                    return _member === member;
                });
                return _members.length > 0;
            });
            // check ALL filter members were matched
            return members.length === _filter.members.length;
        };

        // check filter.members array has any matches with _moment's members
        const filterTags = (_moment) => {
            const tags = _filter.tags.filter((tag) => {
                const _tags = _moment.tags.filter((_tag) => {
                    return _tag === tag;
                });
                return _tags.length > 0;
            });
            // check ALL filter tags were matched
            return tags.length === _filter.tags.length;
        };

        const filterLocation = (_moment) => {
            return _moment.location === _filter.location[0];
        };

        const _filteredMoments = sortedAllMoments.filter((_moment) => {
            // if filter contains locations, apply location filter
            const locationMatch = _filter.location.length > 0 ? filterLocation(_moment) : true;

            // if filter contains members, apply members filter
            const memberMatch = _filter.members.length > 0 ? filterMembers(_moment) : true;

            // if filter contains tags, apply tags filter
            const tagMatch = _filter.tags.length > 0 ? filterTags(_moment) : true;

            return locationMatch && memberMatch && tagMatch;
        });

        return _filteredMoments;
    };

    useEffect(() => {
        if (sortedAllMoments.length) {
            const _filteredMoments = applyFilter(filter);
            if (_filteredMoments.length) {
                setFilteredMoments(_filteredMoments);

                console.log("currentMomentID", currentMomentID);
                // const current = _filteredMoments.find((_moment) => _moment.id === currentMomentID);
                // if (!current) {
                console.log("didn't find current");
                setCurrentMomentID(_filteredMoments[_filteredMoments.length - 1].id);
                setCurrentDate(_filteredMoments[_filteredMoments.length - 1].date);
                setLatestDate(_filteredMoments[_filteredMoments.length - 1].date);

                setCurrentMomentIDLeft(_filteredMoments[_filteredMoments.length - 1].id);
                setCurrentDateLeft(_filteredMoments[_filteredMoments.length - 1].date);
                setCurrentMomentIDRight(_filteredMoments[_filteredMoments.length - 1].id);
                setCurrentDateRight(_filteredMoments[_filteredMoments.length - 1].date);
                // }
                const _locations = getLocations(_filteredMoments);
                const _tags = getTags(_filteredMoments);
                setLocations(_locations);
                setTags(_tags);
                setFilteredYears(GetYears(_filteredMoments));

                setFilteredMomentsLeft(_filteredMoments, filter);
                setFilteredYearsLeft(GetYears(_filteredMoments));

                setFilteredMomentsRight(_filteredMoments, filter);
                setFilteredYearsRight(GetYears(_filteredMoments));

                setCountLikedMoments(_filteredMoments.filter((moment) => moment.isLike).length);
            } else {
                setInvalidFilter(true);
            }
        }
    }, [filter, sortedAllMoments, isLikeView]);

    useEffect(() => {
        //
        // UPDATE COMPARE-MODE LEFT FILTER
        //
        if (sortedAllMoments.length && filteredMomentsLeft.length) {
            console.log("Left << FILTERING MOMENTS");
            const _filteredMoments = applyFilter(filterLeft);
            if (_filteredMoments.length) {
                setFilteredMomentsLeft(_filteredMoments);
                setCurrentMomentIDLeft(_filteredMoments[_filteredMoments.length - 1].id);
                setCurrentDateLeft(_filteredMoments[_filteredMoments.length - 1].date);
                setLatestDate(_filteredMoments[_filteredMoments.length - 1].date);
                setFilteredYearsLeft(GetYears(_filteredMoments));
            } else {
                setInvalidFilter(true);
            }
        }
    }, [filterLeft]);

    useEffect(() => {
        //
        // UPDATE COMPARE-MODE RIGHT FILTER
        //
        if (sortedAllMoments.length && filteredMomentsRight.length) {
            console.log("Right << FILTERING MOMENTS");
            const _filteredMoments = applyFilter(filterRight);
            if (_filteredMoments.length) {
                setFilteredMomentsRight(_filteredMoments);
                setCurrentMomentIDRight(_filteredMoments[_filteredMoments.length - 1].id);
                setCurrentDateRight(_filteredMoments[_filteredMoments.length - 1].date);
                setLatestDate(_filteredMoments[_filteredMoments.length - 1].date);
                setFilteredYearsRight(GetYears(_filteredMoments));
            } else {
                setInvalidFilter(true);
            }
        }
    }, [filterRight]);

    return (
        <>
            {(filteredMoments && currentMomentID && currentDate) || (filteredMomentsLeft && currentMomentIDLeft && currentDateLeft) || (filteredMomentsRight && currentMomentIDRight && currentDateLeft) ? (
                <Moments.Provider
                    value={{
                        allMembers,
                        currentMomentID,
                        currentDate,
                        latestDate,
                        filteredMoments,
                        filteredMomentsLeft,
                        filteredMomentsRight,
                        isCompareView,
                        isMonthView,
                        isLikeView,
                        gallerySize,
                        filter,
                        filterLeft,
                        filterRight,
                        locations,
                        tags,
                        filteredYears,
                        filteredYearsLeft,
                        filteredYearsRight,
                        currentMomentIDLeft,
                        currentMomentIDRight,
                        currentDateLeft,
                        currentDateRight,
                        sortedAllMoments,
                        countLikedMoments,
                        invalidFilter,
                        checkFilter,
                        likedMoments,
                        onLike,

                        setCurrentMomentID,
                        setCurrentDate,
                        setLatestDate,
                        setFilteredMoments,
                        setFilteredMomentsLeft,
                        setFilteredMomentsRight,
                        setIsCompareView,
                        setIsMonthView,
                        setIsLikeView,
                        setFilter,
                        setFilterLeft,
                        setCurrentMomentIDLeft,
                        setCurrentDateLeft,
                        setFilterRight,
                        setCurrentMomentIDRight,
                        setCurrentDateRight,
                        setLikedMoments,
                    }}
                >
                    {props.children}
                </Moments.Provider>
            ) : (
                ""
            )}
        </>
    );
};

export default MomentsContextProvider;
